// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-tournament__container {
    background-color: var( --white-color );
    padding: 24px 0 0 0;
    /* border: 1px solid var(--new-gray-background-color);
    border-radius: calc( var( --space ) - var( --space-eighth ) ); */
    /* margin-left: var(--space-x2);
    margin-right: var(--space-x2); */
}

.league-tournament__container__tabs.MuiTabs-root {
    width: 50%;
}

.league-tournament__container__tabs .MuiTabs-flexContainer {
    border-bottom: none;
}

.league-tournament__separator {
    width: 100%;
    height: 0;
    border-bottom: 1px solid var( --new-gray-background-color );
    margin-bottom: var( --space-and-half );
}

.league-tournament__container__tabs .MuiTab-wrapper {
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: var( --font-medium );
    font-size: calc(var(--space) + 1px);/*17px*/
    line-height: calc(var(--space) + var(--space-quarter));/* 20px */
    letter-spacing: 0.005em;
    text-transform: none;
}

.league-tournament_title.baloa-subtitle-2{
    padding: var(--space-and-half);
    color: var(--primary-dark-color);
}

.league-tournament__tags {
    display: flex;
    margin-left: 24px;
    gap: 12px;
}

.MuiChip-root.league-tournament__tag {
    color: var(--basic-gray-color);
    background-color: var(--white-color);
    border: 1px solid var(--basic-gray-color);
}

.MuiChip-root.league-tournament__tag:hover {
    color: var(--new-green-color);
    background: #EAF7F0;
    border: 1px solid var(--new-green-color);
}

.MuiChip-root.league-tournament__tag.selected {
    color: var(--new-green-color);
    background: #EAF7F0;
    border: 1px solid var(--new-green-color);
}


.MuiChip-root.baloa-table{ 
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: var(--space);/* 16px */
    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    letter-spacing: 0.0025em;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .league_tournament_list_container{
        margin-top: var(--space-half) !important;
    }

    .league-tournament__container{
        margin: 0;
        padding: 12px 0 0 0;
    }

    .league-tournament__tags{
        margin-left: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-component/LeagueTournamentComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,mBAAmB;IACnB;oEACgE;IAChE;oCACgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,2DAA2D;IAC3D,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,iCAAiC;IACjC,mCAAmC,CAAC,OAAO;IAC3C,sDAAsD,CAAC,SAAS;IAChE,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;;AAGA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB,CAAC,SAAS;IACjC,2DAA2D,CAAC,SAAS;IACrE,wBAAwB;AAC5B;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,wCAAwC;IAC5C;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".league-tournament__container {\n    background-color: var( --white-color );\n    padding: 24px 0 0 0;\n    /* border: 1px solid var(--new-gray-background-color);\n    border-radius: calc( var( --space ) - var( --space-eighth ) ); */\n    /* margin-left: var(--space-x2);\n    margin-right: var(--space-x2); */\n}\n\n.league-tournament__container__tabs.MuiTabs-root {\n    width: 50%;\n}\n\n.league-tournament__container__tabs .MuiTabs-flexContainer {\n    border-bottom: none;\n}\n\n.league-tournament__separator {\n    width: 100%;\n    height: 0;\n    border-bottom: 1px solid var( --new-gray-background-color );\n    margin-bottom: var( --space-and-half );\n}\n\n.league-tournament__container__tabs .MuiTab-wrapper {\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: var( --font-medium );\n    font-size: calc(var(--space) + 1px);/*17px*/\n    line-height: calc(var(--space) + var(--space-quarter));/* 20px */\n    letter-spacing: 0.005em;\n    text-transform: none;\n}\n\n.league-tournament_title.baloa-subtitle-2{\n    padding: var(--space-and-half);\n    color: var(--primary-dark-color);\n}\n\n.league-tournament__tags {\n    display: flex;\n    margin-left: 24px;\n    gap: 12px;\n}\n\n.MuiChip-root.league-tournament__tag {\n    color: var(--basic-gray-color);\n    background-color: var(--white-color);\n    border: 1px solid var(--basic-gray-color);\n}\n\n.MuiChip-root.league-tournament__tag:hover {\n    color: var(--new-green-color);\n    background: #EAF7F0;\n    border: 1px solid var(--new-green-color);\n}\n\n.MuiChip-root.league-tournament__tag.selected {\n    color: var(--new-green-color);\n    background: #EAF7F0;\n    border: 1px solid var(--new-green-color);\n}\n\n\n.MuiChip-root.baloa-table{ \n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: var(--space);/* 16px */\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    letter-spacing: 0.0025em;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .league_tournament_list_container{\n        margin-top: var(--space-half) !important;\n    }\n\n    .league-tournament__container{\n        margin: 0;\n        padding: 12px 0 0 0;\n    }\n\n    .league-tournament__tags{\n        margin-left: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
